/*! JointJS+ v4.2.2 (2026-01-22) - HTML5 Diagramming Framework

Copyright (c) 2025 client IO

This Source Code Form is subject to the terms of the JointJS+
License, v. 2.0. If a copy of the JointJS+ License was not
distributed with this file, You can obtain one at
https://www.jointjs.com/license or from the JointJS+ archive as was
distributed by client IO. See the LICENSE file.
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ui } from '@joint/plus';
var Position = ui.Halo.HandlePosition;
var HaloService = /** @class */ (function () {
    function HaloService() {
    }
    HaloService.prototype.create = function (cellView) {
        var halo = new ui.Halo({
            cellView: cellView,
            boxContent: null,
            handles: this.getHaloConfig(),
            useModelGeometry: true,
        });
        halo.render();
    };
    HaloService.prototype.getHaloConfig = function () {
        return [
            __assign(__assign({}, ui.Halo.getDefaultHandle('remove')), { position: Position.NW, attrs: {
                    '.handle': {
                        'data-tooltip-class-name': 'small',
                        'data-tooltip': 'Click to remove the object',
                        'data-tooltip-position': 'right',
                        'data-tooltip-padding': 15
                    }
                } }),
            __assign(__assign({}, ui.Halo.getDefaultHandle('unlink')), { position: Position.W, attrs: {
                    '.handle': {
                        'data-tooltip-class-name': 'small',
                        'data-tooltip': 'Click to break all connections to other objects',
                        'data-tooltip-position': 'right',
                        'data-tooltip-padding': 15
                    }
                } }),
            __assign(__assign({}, ui.Halo.getDefaultHandle('rotate')), { position: Position.SW, attrs: {
                    '.handle': {
                        'data-tooltip-class-name': 'small',
                        'data-tooltip': 'Click and drag to rotate the object',
                        'data-tooltip-position': 'right',
                        'data-tooltip-padding': 15
                    }
                } }),
            __assign(__assign({}, ui.Halo.getDefaultHandle('fork')), { position: Position.NE, attrs: {
                    '.handle': {
                        'data-tooltip-class-name': 'small',
                        'data-tooltip': 'Click and drag to clone and connect the object in one go',
                        'data-tooltip-position': 'left',
                        'data-tooltip-padding': 15
                    }
                } }),
            __assign(__assign({}, ui.Halo.getDefaultHandle('link')), { position: Position.E, attrs: {
                    '.handle': {
                        'data-tooltip-class-name': 'small',
                        'data-tooltip': 'Click and drag to connect the object',
                        'data-tooltip-position': 'left',
                        'data-tooltip-padding': 15
                    }
                } }),
            __assign(__assign({}, ui.Halo.getDefaultHandle('clone')), { position: Position.SE, attrs: {
                    '.handle': {
                        'data-tooltip-class-name': 'small',
                        'data-tooltip': 'Click and drag to clone the object',
                        'data-tooltip-position': 'left',
                        'data-tooltip-padding': 15
                    }
                } })
        ];
    };
    return HaloService;
}());
export { HaloService };
